// routes
import { createRouter, createWebHistory } from "vue-router";
// import store from "@/services/store";

import Default from "@/views/Default.vue";
import NoPlanner from "@/views/NoPlanner.vue";

import Signin from "@/views/auth/Signin.vue";
import Unauthorized from "@/views/auth/Unauthorized.vue";
import Signout from "@/views/auth/Signout.vue";
import util from "@/services/util";
import { useAuthenticatedUserStore } from "@/modules/authentication/authentication-store";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "default", component: Default },
    {
      name: "planning-create",
      path: "/planning/create",
      meta: { skipUserInit: true },
      redirect: (to) => {
        return util.isMobile()
          ? {
              name: "mobile-select",
              query: {
                type: "workorder",
                date: new Date().toLocaleDateString("sv-SE", {
                  dateStyle: "short",
                }),
                workOrderNumber: to.query.workOrderNumber,
                utm_source: to.query.utm_source,
              },
            }
          : {
              name: "start",
              query: {
                workOrderNumber: to.query.workOrderNumber,
                utm_source: to.query.utm_source,
              },
            };
      },
    },
    {
      path: "/noplanner",
      name: "noplanner",
      meta: { skipUserInit: true },
      component: NoPlanner,
    },
    {
      path: "/signin",
      name: "signin",
      meta: { skipUserInit: true },
      component: Signin,
    },
    {
      path: "/unauthorized",
      name: "Unauthorized",
      meta: { skipUserInit: true },
      component: Unauthorized,
    },
    {
      path: "/signout",
      name: "signout",
      meta: { skipUserInit: true },
      component: Signout,
    },
    {
      path: "/start",
      name: "start",
      meta: { requiresAuth: true },
      props: (route) => ({ workOrderNumber: route.query.workOrderNumber }),
      component: () => import("@/views/Start.vue"),
    },
    {
      path: "/map",
      name: "map",
      meta: { requiresAuth: true },
      component: () => import("@/views/Map.vue"),
    },
    {
      path: "/mobile",
      name: "mobile",
      meta: { requiresAuth: true },
      component: () => import("@/views/Mobile.vue"),
    },
    {
      path: "/mobile-select",
      name: "mobile-select",
      meta: { requiresAuth: true },
      props: (route) => ({ workOrderNumber: route.query.workOrderNumber }),
      component: () => import("@/views/MobileSelect.vue"),
    },
    {
      path: "/mobile-edit",
      name: "mobile-edit",
      meta: { requiresAuth: true },
      component: () => import("@/views/MobileEdit.vue"),
    },
    {
      path: "/user/logged-out",
      name: "user--logged-out",
      meta: { requiresAuth: false, skipUserInit: true },
      component: () => import("@/modules/user/views/LoggedOut.vue"),
    },
  ],
});

router.beforeEach(async (to, _, next) => {
  const store = useAuthenticatedUserStore();

  /*
  function hasAccess(meta: RouteLocationNormalized["meta"]) {
    if (!store.user.roles.includes("se.eaztimate.hubb")) {
      return false;
    }

    const restrictToRoles = meta?.restrictToRoles;
    return !restrictToRoles || restrictToRoles.some((r: UserRole) => store.user.roles.includes(r));
  }*/

  // ensure that store.state.user is initialized with any current user and roles
  const { requiresAuth, skipUserInit } = to.meta ?? {};

  if (requiresAuth || !skipUserInit) {
    // we need this if requiresAuth == true but may otherwise skip it if skipUserInit == true
    await store.userInit();
  }

  if (requiresAuth) {
    if (!store.user.isAuthenticated) {
      await store.userLogin(to.fullPath);
      next(false);
      return;
    }
  }

  next();
});

export default router;
